/**
 * Masses are integers in hundredths of the display unit (82.5 kg → 8250, 185 lb → 18500).
 * Every plate in common use is a multiple of 0.25 kg or 1.25 lb, so integer arithmetic is exact.
 */
export type Unit = 'kg' | 'lb';

/** An integer number of hundredths of the gym's unit. */
export type Mass = number;

export const SCALE = 100;

export function mass(display: number): Mass {
  const v = Math.round(display * SCALE);
  if (!Number.isFinite(v)) throw new RangeError(`Invalid mass: ${display}`);
  return v;
}

export function toDisplay(m: Mass): number {
  return m / SCALE;
}

/** "82.5", "55", "1.25", trailing zeros dropped. */
export function formatMass(m: Mass): string {
  return String(toDisplay(m));
}

const KG_PER_LB = 0.45359237;

/** Convert between units, rounded down to `step` (rounding down is the safe direction for loads). */
export function convert(m: Mass, from: Unit, to: Unit, step: Mass = 1): Mass {
  if (from === to) return m;
  const raw = from === 'kg' ? m / KG_PER_LB : m * KG_PER_LB;
  return Math.floor(raw / step) * step;
}
